<template>
  <el-dialog
    v-drag
    :title="title"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="800px"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="2vh"
  >
    <div v-loading="loading" class="dialog-content">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item :label="activeName === '20' ? '抬头名称' : '仓库代码'" prop="name">
          <el-input
            v-model="form.name"
            style="width: 672px"
            placeholder="仅限除中文的字符"
            @input="onInput('name')"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="+activeName === 0" label="公司名称" prop="companyName">
          <el-input
            v-model="form.companyName"
            style="width: 672px"
            placeholder="仅限除中文的字符"
            @input="onInput('companyName')"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家/省州" prop="cascader">
          <el-cascader
            ref="myCascader"
            v-model="form.cascader"
            style="width: 320px"
            placeholder="请选择国家"
            :options="addressDropCodeOption"
            @change="cascaderChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="城市" prop="cityAddress">
          <el-input
            v-model="form.cityAddress"
            style="width: 320px"
            maxlength="30"
            placeholder="仅限填写数字和英文字符"
            @input="onInput('cityAddress')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="postcode" label="邮编">
          <el-input
            v-model="form.postcode"
            style="width: 320px"
            placeholder="仅限填写数字、英文字符和 “ - ”，最多12位"
            :maxlength="12"
            @input="onInput('postcode')"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.address }}</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="+activeName === 0 || +activeName === 20"
          label="客户"
          prop="companyId"
        >
          <el-select
            v-model="form.companyId"
            style="width: 320px"
            filterable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in companyDrapdown"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人" prop="contact">
          <el-input
            v-model="form.contact"
            style="width: 320px"
            placeholder="仅限除中文的字符"
            @input="onInput('contact')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phoneNumber">
          <span slot="label" class="label-title">
            联系电话<span>(最少10位，最多15位)</span>
          </span>
          <el-input
            v-model="form.phoneNumber"
            style="width: 320px"
            placeholder="仅限输入数字、英文括号、横杠字符"
            :maxlength="15"
            @input="onInput('phoneNumber')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item v-if="activeName === '20'" label="所属" prop="permission">
          <el-select v-model="form.permission" style="width: 320px;" placeholder="请选择">
            <el-option
              v-for="item in permissionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            style="width: 320px"
            placeholder="请填写邮箱"
            @input="onInput('email')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="activeName === '20'"
          label="税号"
          class="taxNum"
          prop="taxNo"
        >
          <span v-if="activeName === '20'" slot="label" class="form-label">
            税号
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">
                美国EIN号码格式为：12-345678900<br />离岸进口商EIN号码格式为：123456-78900
              </div>
              <img src="@/assets/images/seting/question.png" alt="" />
            </el-tooltip>
          </span>
          <el-input
            v-model="form.taxNo"
            style="width: 320px"
            placeholder="仅限填写数字和横杠字符"
            @input="onInput('taxNo')"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="activeName === '20'" label="类型" prop="type">
          <el-select
            v-model="form.type"
            style="width: 672px"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="activeName === '20'"
          label="MID"
          prop="mid"
        >
          <el-input v-model="form.mid" style="width: 672px" />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="form.address"
            :style="{ width: +activeName === 0 ? '320px' : '672px' }"
            placeholder="仅限除中文的字符，最多输入100位"
            :maxlength="100"
            @input="onInput('address')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div v-loading="loading" class="ok flex_c_c" @click="ok('form')">
        确 定
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { saveScin, saveAddressBook } from '@/api/basic'
import { isValidEmail } from '@/utils/validate'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    activeName: {
      type: String,
      default: '0'
    },
    isSelectType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value.length < 10) {
        return callback(new Error('电话格式不正确'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!isValidEmail(value)) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        callback()
      }
    }
    return {
      options: [
        {
          value: 0,
          label: 'Shipper(发货人)'
        },
        {
          value: 1,
          label: 'Consignee(收货人)'
        },
        // {
        //   value: 2,
        //   label: 'Importer(进口商)'
        // },
        {
          value: 3,
          label: 'Notify Party(通知方)'
        },
        {
          value: 4,
          label: 'Manufacturer(制造商)'
        },
        {
          value: 5,
          label: 'Ultimate Consignee(最终收货人)'
        },
        {
          value: 6,
          label: 'Buyer(买方)'
        },
        {
          value: 7,
          label: 'Seller(卖方)'
        },
        {
          value: 8,
          label: 'Ship To Party(到货方)'
        },
        {
          value: 9,
          label: 'Consolidator(集拼方)'
        },
        {
          value: 10,
          label: 'Stuffing(装箱方)'
        }
      ],
      permissionOptions: [
        {
          value: 0,
          label: '内部'
        },
        {
          value: 1,
          label: '外部'
        }
      ],
      form: {
        cascader: [],
        code: '',
        address: '',
        postcode: '',
        phoneNumber: '',
        contact: '',
        name: '',
        email: '',
        countryId: '',
        companyId: '',
        state: '',
        cityAddress: '',
        taxNo: '',
        suCode: '',
        type: undefined,
        mid: undefined,
        permission: 0,
        companyName: ''
      },
      loading: false,
      title: '新增-私仓',
      rules: {
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请填写代码', trigger: 'blur' }],
        companyName: [{ required: true, message: '请填写公司名称', trigger: 'blur' }],
        phoneNumber: [
          { required: true, message: '请填写联系电话', trigger: 'blur' },
          { validator: validatePhone }
        ],
        email: [{ validator: validateEmail }],
        postcode: [{ required: true, message: '请填写邮编', trigger: 'blur' }],
        cascader: [
          { required: true, message: '请选择国家/省州', trigger: 'change' }
        ],
        cityAddress: [
          { required: true, message: '请输入城市', trigger: 'blur' }
        ],
        countryId: [
          { required: true, message: '请选择国家', trigger: 'change' }
        ],
        // companyId: [
        //   { required: true, message: '请选择客户', trigger: 'change' }
        // ],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        state: [{ required: true, message: '请输入省份', trigger: 'change' }],
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }]
      },
      tabItems: [
        {
          id: 0,
          name: '私仓'
        },
        {
          id: 1,
          name: '亚马逊仓'
        },
        {
          id: 100,
          name: '沃尔玛仓'
        }
        // {
        //   id: 103,
        //   name: '自营'
        // }
      ]
    }
  },
  computed: {
    ...mapGetters(['addressDropOption', 'companyDrapdown']),
    addressDropCodeOption() {
      return this.addressDropOption.map((item) => {
        return {
          value: item.value,
          label: `${item.label}`,
          children: item.children.map((a) => {
            return {
              label: a.label,
              value: a.value
            }
          })
        }
      })
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        this.$refs['form']?.resetFields()
        // 确保地址数据已加载
        if (!this.addressDropOption || this.addressDropOption.length === 0) {
          await this.$store.dispatch('getAddress')
          // 等待 Vue 完成 DOM/响应式更新
          await this.$nextTick()
        }

        this.code = ''
        let str = ''
        switch (this.activeName) {
          case '0':
            str = this.editData.id ? '修改-仓库' : '新增-仓库'
            break
          case '20':
            str = this.editData.id ? '修改-抬头信息' : '新增-抬头信息'
            break
          default:
            str = this.editData.id ? '修改-私仓' : '新增-私仓'
            break
        }
        this.title = str
        if (this.isSelectType && this.editData.id) {
          this.title = '修改仓库'
        }
        if (this.isSelectType && !this.editData.id) {
          this.title = '新增仓库'
        }

        if (this.editData.id) {
          // 确保 addressDropCodeOption 已经更新
          const countryId = this.editData.countryId
          const provinceId = this.editData.provinceId

          // 安全检查
          const country = this.addressDropCodeOption.find(
            (item) => item.value === countryId,
          )
          if (country && country.children) {
            const provinceExists = country.children.some(
              (child) => child.value === provinceId,
            )
            console.log('Province exists:', provinceExists)
          } else {
            console.warn('Country not found or has no children')
          }

          this.form = {
            ...this.editData,
            name: this.editData.name || this.editData.code,
            cityAddress: this.editData.cityAddress || this.editData.city,
            cascader: [countryId, provinceId]
          }
        } else {
          this.form = {
            cascader: [],
            code: '',
            address: '',
            addressLine2: '',
            postcode: '',
            phoneNumber: '',
            contact: '',
            name: '',
            email: '',
            countryId: '',
            provinceId: '',
            companyId: '',
            state: '',
            cityAddress: '',
            taxNo: '',
            suCode: '',
            type: undefined,
            mid: undefined,
            permission: 0,
            companyName: ''
          }
        }
      }
    }
  },
  mounted() {
    if (!this.addressDropOption || this.addressDropOption.length === 0) {
      this.$store.dispatch('getAddress')
    }
  },
  methods: {
    onInput(type) {
      type === 'code' &&
        this.$set(
          this.form,
          'code',
          this.form.code.replace(/[^0-9a-zA-Z]/g, '').toUpperCase(),
        )
      type === 'postcode' &&
        this.$set(
          this.form,
          'postcode',
          this.form.postcode.replace(/[^0-9a-zA-Z-]/g, ''),
        )
      type === 'state' &&
        this.$set(
          this.form,
          'state',
          this.form.state.replace(/[^\da-zA-Z]/g, ''),
        )
      type === 'cityAddress' &&
        this.$set(
          this.form,
          'cityAddress',
          this.form.cityAddress.replace(/[^\da-zA-Z ]/g, ''),
        )
      type === 'contact' &&
        this.$set(
          this.form,
          'contact',
          this.form.contact.replace(/[\u4e00-\u9fa5]/g, ''),
        )
      type === 'phoneNumber' &&
        this.$set(
          this.form,
          'phoneNumber',
          this.form.phoneNumber.replace(/[^0-9()-]/g, ''),
        )
      type === 'name' &&
        this.$set(
          this.form,
          'name',
          this.form.name.replace(/[\u4e00-\u9fa5]/g, ''),
        )
      type === 'taxNo' &&
        this.$set(this.form, 'taxNo', this.form.taxNo.replace(/[^0-9\-]/g, ''))
      type === 'address' &&
        this.$set(
          this.form,
          'address',
          this.form.address.replace(/[\u4e00-\u9fa5]/g, ''),
        )
    },
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      let params = {
        ...this.form,
        cityAddress: this.form.cityAddress.trim(),
        name: this.form.name.trim(),
        address: this.form.address.trim(),
        companyId: this.form.companyId || this.editData.companyId || 0,
        type: this.form.type
      }
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          if (this.activeName === '20') {
            saveScin(params).then((res) => {
              if (res.success) {
                this.$message.success(res.errorMessage)
                this.$emit('ok')
                this.loading = false
              } else {
                this.$message.error(res.errorMessage)
                this.loading = false
              }
            })
          } else {
            params = {
              type: 0,
              ...params,
              city: params.cityAddress,
              code: params.name
            }
            saveAddressBook(params).then((res) => {
              if (res.success) {
                this.$message.success(res.errorMessage)
                this.$emit('ok')
                this.loading = false
              } else {
                this.$message.error(res.errorMessage)
                this.loading = false
              }
            })
          }
        } else {
          return false
        }
      })
    },
    cascaderChange() {
      this.form.countryId = this.form.cascader[0]
      this.form.provinceId = this.form.cascader[1]
    },
    tabChange(type) {
      type.id && (this.form.companyId = '')
      this.form.type = type.id
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-content {
  width: calc(100% - 88px);
  margin: 0 auto;
}

.footers {
  display: flex;
  justify-content: center;

  & div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }

  .cancel {
    background: #eeeeee;
    color: #999999;
  }

  .ok {
    background: rgb(18, 88, 188);
    color: #ffffff;
    margin-left: 20px;
    cursor: pointer;
  }
}

.el-form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0 0 0 0;
}

/deep/ .el-form-item {
  margin-bottom: 10px;
}

/deep/ .el-form-item__label {
  line-height: 30px !important;
}

/deep/ .el-col:nth-child(2n) {
  display: flex;
  justify-content: flex-end;
}

.label-title {
  span {
    color: red;
    font-size: 12px;
  }
}

/deep/ .taxNum .el-form-item__label {
  display: flex;
}

.form-label {
  display: flex;
  align-items: center;
}
</style>
